import CityPage from '../../components/CityPage';

const cityData = {
    name: "Villerville",
    slug: "villerville",
    postalCode: "14113",
    intro: "CC Débarras 14 assure des débarras à Villerville et sur toute la côte normande entre Trouville et Honfleur. Ce charmant village balnéaire abrite de nombreuses résidences secondaires et maisons de famille dont nous prenons régulièrement en charge le débarras. Succession, vente, déménagement ou simple vide-maison : notre équipe intervient avec sérieux et discrétion, pour un débarras complet ou partiel.",
    nearby: ["Trouville-sur-Mer", "Honfleur", "Deauville", "Touques"],
};

const Villerville = () => <CityPage city={cityData} />;

export default Villerville;
